// extracted by mini-css-extract-plugin
module.exports = {" _key":"@dojo/widgets/grid","root":"grid-m__root__2aK23","header":"grid-m__header__v8iMF","filterGroup":"grid-m__filterGroup__1dfAm"};